<template>
   <div class="grids">
					<div class="progressbar-heading grids-heading">
						<h2>UPDATE AWARDEE INFO</h2>
                               
       
        
        
        
       
       
       
        
        
        
					</div>
					<div class="panel panel-widget forms-panel">
                        <div class="form-body">
									<form v-on:submit.prevent="handleSubmit()"> 
                                    <div class="form-group"> 
                                    <label for="awardName">awardName</label> 
                                    <input type="text" class="form-control" id="awardName"  v-model="awardName" placeholder="Award Name" v-on:change="handleawardeeName($event)">
                                     </div>
                                      <div class="form-group">
                                      <label for="honour">Honour</label> 
                                      <input type="text" class="form-control" id="honour" v-model="Honour" placeholder="Honour" v-on:change="handleHonour($event)">
                                       </div> 
                                       <div class="form-group">
                                      <label for="awardYear">award Year</label> 
                                      <input type="text" class="form-control" id="awardYear" v-model="awardYear" placeholder="award Year" v-on:change="handleawardYear($event)">
                                       </div> 
                                       
                                       <div class="form-group">
                                      <label for="awardeeCountry">awardeeCountry</label> 
                                      <input type="text" class="form-control" id="awardeeCountry" v-model="awardeeCountry" placeholder="Awardee Country"  v-on:change="handleawardeeCountry($event)">
                                       </div> 
                                       <div class="form-group">
                                      <label for="awardCategory">awardCategory</label> 
                                      <input type="text" class="form-control" id="awardCategory" v-model="awardCategory" placeholder="Award Category" v-on:change="handleawardCategory($event)">
                                       </div> 
                                       <div class="form-group">
                                      <label for="awardeeTitle">awardeeTitle</label> 
                                      <input type="text" class="form-control" id="awardeeTitle"  v-model="awardeeTitle" placeholder="Awardee Title" v-on:change="handleawardeeTitle($event)">
                                       </div> 
                                       <div class="form-group">
                                      <label for="context">context</label> 
                                      <input type="text" class="form-control" id="context"  v-model="context" placeholder="Context" v-on:change="handleContext($event)">
                                       </div> 
                                       <div class="form-group">
                                      <label for="biography">biography</label> 
                                      <input type="text" class="form-control" id="biography"  v-model="biography" placeholder="Biography" v-on:change="handleBiography($event)">
                                       </div> 
                                       <div class="form-group">
                                      <label for="awardeeBirthYear">awardeeBirthYear</label> 
                                      <input type="text" class="form-control" id="awardeeBirthYear" v-model="awardeeBirthYear" placeholder="Awardee BirthYear" v-on:change="handleBirthYear($event)">
                                       </div> 
                                       <div class="form-group">
                                      <label for="awardeeDeathYear">awardeeDeathYear</label> 
                                      <input type="text" class="form-control" id="awardeeDeathYear" v-model="awardeeDeathYear" placeholder="Awardee DeathYear" v-on:change="handleDeathYear($event)">
                                       </div> 
                                       
                                       <div class="form-group">
                                        <label for="awardeeProfileImage">Awardee ProfileImage</label> 
                                        <input type="file" v-on:change="changeImage($event)" ref="file" />    
                                    
                                         </div> 
                                        
                                          <button type="submit" class="btn btn-default">Submit</button>
                                           </form> 
								</div>
					</div>
					
					
               
                    <button @click="logout()" class="btn btn-default">logout</button>
					
				</div>

</template>

<script>
import axios from "axios";
export default {
  name: 'About',
  props: {
   profileId:
   {
        type: String,
        required: true
   }
},
data()
{
    return{
         awardYear:null,
        awardName:null,
        Honour:null,
        awardeeCountry:null,
        awardCategory:null,
        awardeeTitle:null,
        context:null,
        biography:null,
        awardeeBirthYear:null,
        awardeeDeathYear:null,
        awardeeProfileImage:null,
        urlData: null,
        profileDetails:[]
    }
},
async mounted()
{
    this.urlData = this.profileId;

     try
     {
    //get user access token
    let token = localStorage.getItem("token");
    
     if((token == "noToken") || (token == null))
    {
      alert("Ilegal page view");
       this.$router.push("/");
    }

     let userDataResponse = await axios({
       method: "get",
       url: "https://time-person-mofe.herokuapp.com/api/dashboard/profile",
       headers: {"Authorization": "Bearer "+token}
     });

    let requestStatus = userDataResponse.data.status;

    if(requestStatus != "success")
    {
      this.$router.push("/");
      
    }
    
  }
  catch(error)
  {
    //alert("User data not available please refresh page."+error);

    //redirect away from dashboard
    this.$router.push("/");
  }
 

    //make axios graphql query to obtain profile details
	    try{
                    let token = localStorage.getItem("token");
    
                    let graphResponse = await axios.post("https://time-person-mofe.herokuapp.com/graphql",
                    {
                       query:`
                      {
					FullProfileResult(profileId: "${this.urlData}")
					{
						awardYear
						awardName
						honour
						awardeeCountry
						awardCategory
						awardeeProfileImage
						awardeeTitle
						profileId
						context
						biography
						awardeeBirthYear
						awardeeDeathYear
						view
						status
					}
					}
					   `
					   },
					   {"Authorization": "Bearer "+token});

					//process response
                         
                         if(graphResponse.data.data.FullProfileResult.status == "success")
                         {
                         this.awardYear = graphResponse.data.data.FullProfileResult.awardYear;
                         this.awardName = graphResponse.data.data.FullProfileResult.awardName;
                         this.Honour = graphResponse.data.data.FullProfileResult.honour;
                         this.awardeeCountry = graphResponse.data.data.FullProfileResult.awardeeCountry;
                         this.awardCategory = graphResponse.data.data.FullProfileResult.awardCategory;
                         this.awardeeProfileImage = graphResponse.data.data.FullProfileResult.awardeeProfileImage;
                         this.awardeeTitle = graphResponse.data.data.FullProfileResult.awardeeTitle;
                         this.context = graphResponse.data.data.FullProfileResult.context;
                         this.biography = graphResponse.data.data.FullProfileResult.biography;
                         this.awardeeBirthYear = graphResponse.data.data.FullProfileResult.awardeeBirthYear;
                         this.awardeeDeathYear = graphResponse.data.data.FullProfileResult.awardeeDeathYear;
                         }

                         
               //v-model="awardeeProfileImage"
                   //alert(JSON.stringify(graphResponse.data));

            }
            catch(error)
            {
                 alert("User profile data not fetched please refresh "+error.message);
            }
    
}
,
created()
{
       //this.urlData = this.profileId;
    //make axios graphql query to obtain profile details, get the details and then display in form fields
},
methods:
{
     handleawardeeName: function(e)
    {
         
        this.awardName = e.target.value;
    },
     handleawardYear: function(e)
    {
         
        this.awardYear = e.target.value;
    },
    handleHonour: function(e)
    { 
         this.Honour = e.target.value;
    },
    handleawardeeCountry: function(e)
    {  
         this.awardeeCountry = e.target.value;
    },
    handleawardCategory: function(e)
    { 
         this.awardCategory = e.target.value;
    },
    handleawardeeTitle: function(e)
    {  
         this.awardeeTitle = e.target.value;
    },
    handleContext: function(e)
    {  
         this.context = e.target.value;
    },
    handleBiography: function(e)
    {
         this.biography = e.target.value;
    },
    handleBirthYear: function(e)
    {  
         this.awardeeBirthYear = e.target.value;
    },
    handleDeathYear: function(e)
    {  
         this.awardeeDeathYear = e.target.value;
    },
     changeImage: function(e)
        {
            //let imageInput = e.target.value;
            let file = e.target.files;
            let reader = new FileReader();
            reader.readAsDataURL(file[0]);
            reader.onload = (e) => {
               // alert(e.target.result);
                this.awardeeProfileImage = e.target.result;
            }

            //this.setState({"image": imageInput});
            //console.log(e.target.files);
        },
    handleSubmit: async function()
    {
        if((this.awardYear != null) && (this.awardYear != "") && (this.awardName != null) && (this.Honour != null) && (this.awardeeCountry != null) && (this.awardCategory != null) && (this.awardeeTitle != null) && (this.context != null) && (this.biography != null) && (this.awardeeBirthYear != null) && (this.awardeeDeathYear != null) && (this.awardeeProfileImage != null) && 
     (this.awardName != "") && (this.Honour != "") && (this.awardeeCountry != "") && (this.awardCategory != "") && (this.awardeeTitle != "") && (this.context != "") && (this.biography != "") && (this.awardeeBirthYear != "") && (this.awardeeDeathYear != "") && (this.awardeeProfileImage != ""))
     {
            //make axios call to graphql api
             try{
                    let token = localStorage.getItem("token");
    
                    let graphResponse = await axios({
                    method: "post",
                    url: "https://time-person-mofe.herokuapp.com/api/updateProfile",
                    data: {awardYear: this.awardYear,
                                        awardName: this.awardName,
                                        honour: this.Honour,
                                        awardeeCountry: this.awardeeCountry,
                                        awardCategory: this.awardCategory,
                                        awardeeProfileImage: this.awardeeProfileImage,
                                        awardeeTitle: this.awardeeTitle,
                                        context: this.context,
                                        biography: this.biography,
                                        awardeeBirthYear: this.awardeeBirthYear,
                                        awardeeDeathYear: this.awardeeDeathYear,
                                        profileId: this.urlData 
                                        
                         },
                      headers: {"Authorization": "Bearer "+token}
                    });

                    //process response
                  // alert(JSON.stringify(graphResponse.data));
                   if(graphResponse.data.data.status == "success")
                         {
                         this.awardYear = graphResponse.data.data.awardYear;
                         this.awardName = graphResponse.data.data.awardName;
                         this.Honour = graphResponse.data.data.honour;
                         this.awardeeCountry = graphResponse.data.data.awardeeCountry;
                         this.awardCategory = graphResponse.data.data.awardCategory;
                         this.awardeeProfileImage = graphResponse.data.data.awardeeProfileImage;
                         this.awardeeTitle = graphResponse.data.data.awardeeTitle;
                         this.context = graphResponse.data.data.context;
                         this.biography = graphResponse.data.data.biography;
                         this.awardeeBirthYear = graphResponse.data.data.awardeeBirthYear;
                         this.awardeeDeathYear = graphResponse.data.data.awardeeDeathYear;

                         //alert suucess
                          alert("Data updated successfully!");
                         }


            }
            catch(error)
            {
                 alert("Error saving profile data "+error.message);
            }
           
        }
        else
        {
             alert("Please fill form properly before submitting");
        } 
    },
     logout: function()
  {
    
    this.$router.push("/timeawards/logout");
  }
}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
